/** The four kinds of issue. What each one is: feature_watchdog/issues.md. */
export const KINDS = [
    { key: "errored", title: "Errored" },
    { key: "indexability", title: "Indexability" },
    { key: "orphaned", title: "Orphaned" },
    { key: "content", title: "Content" },
];

export const titleOf = (key) => KINDS.find((kind) => kind.key === key).title;

/** What broke, the finest grouping of issues, each with its own colour; an issue whose detail names two reasons has both. */
export const CAUSES = [
    { key: "404", label: "404", color: "#D92D20" },
    { key: "otherErrors", label: "Other errors", color: "#F79009" },
    { key: "canonicalised", label: "Canonicalised", color: "#6941C6" },
    { key: "noindex", label: "Noindex", color: "#3B5BDB" },
    { key: "robotsBlocked", label: "Robots-blocked", color: "#0BA5EC" },
    { key: "orphaned", label: "Orphaned", color: "#DD2590" },
    { key: "h1Lost", label: "H1 lost", color: "#0E9384" },
    { key: "titleLost", label: "Title lost", color: "#079455" },
    { key: "metaDescriptionLost", label: "Meta description lost", color: "#98A2B3" },
];

const causeLabelled = (label) => {
    const cause = CAUSES.find((each) => each.label === label);
    if (!cause) throw new Error(`No cause is labelled "${label}"`);
    return cause;
};

export const causesOf = (issue) => {
    if (issue.kind === "errored") return [CAUSES.find((cause) => cause.key === (issue.detail === "404" ? "404" : "otherErrors"))];
    if (issue.kind === "orphaned") return [causeLabelled("Orphaned")];
    return issue.detail.split(", ").map(causeLabelled);
};
